import { Component, OnInit } from '@angular/core';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { CourseStatistics } from '../../models/home-statistics.model';
import { CourseService } from 'src/app/course/services/course.service';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss']
})
export class CounterComponent implements OnInit {
  constructor(private courseService: CourseService, private _IdentityService: IdentityService){}

  /** Unified Code mode: tokenised layout (styles/unified-code/components/_home.scss). */
  get isUnified(): boolean {
    return this._IdentityService.isUnifiedCode();
  }
  courseStatistics: CourseStatistics = {} as CourseStatistics;
  studentCounter: number = 0;
  courseCounter: number = 0;
  pathsCounter: number = 0;
  hoursCounter: number = 0;

  ngOnInit(): void {
    this.getCourseStatistics();
  }

  /**
   * Counts up to `target` without ever passing it: counters used to start at 1, so an empty
   * platform advertised one course, one path and one training hour.
   */
  private countUp(target: number, step: number, delay: number, apply: (value: number) => void) {
    const goal = target > 0 ? target : 0;
    let counter = 0;
    apply(counter);
    const interval = setInterval(() => {
      if (counter >= goal) {
        clearInterval(interval);
        return;
      }
      counter = Math.min(counter + step, goal);
      apply(counter);
    }, delay);
  }

  getCourseStatistics() {
    this.courseService.getCourseStatistics().subscribe((result: CourseStatistics) => {
      this.courseStatistics.courseCount = result.courseCount;
      this.courseStatistics.studentCount = result.studentCount;
      this.courseStatistics.hoursCount = result.hoursCount;
      this.courseStatistics.pathsCount = result.pathsCount;
      this.countUp(result.courseCount, 1, 100, (value) => (this.courseCounter = value));
      this.countUp(result.pathsCount, 1, 150, (value) => (this.pathsCounter = value));
      this.countUp(result.hoursCount, 2, 50, (value) => (this.hoursCounter = value));
      this.countUp(result.studentCount, 1, 100, (value) => (this.studentCounter = value));
    });
  }
}
